"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGiftCardSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M20.657 4c1.84 0 3.34 1.5 3.34 3.34v10.005c0 1.839-1.5 3.34-3.34 3.34H3.34c-1.84 0-3.34-1.501-3.34-3.34V7.34C0 5.5 1.5 4 3.34 4h17.317zm-5.738 4.429l-2.928 3.957L9.063 8.43l-2.354 3.53 2.81 3.797h4.959l2.795-3.796-2.354-3.531z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGiftCardSolid;
exports.default = _default;